export var COLLABORATOR_I18N_KEY = 'collaborator-key';